<canvas #canvas
        class="mt-1"
        (click)="updateMoment($event)"
        [attr.width]="state.canvasWidth"
        [attr.height]="state.canvasHeight">
</canvas>
